import React from "react";
import { CollaborationHeadlines } from "components/pages/Educator/Headlines/CollaborationHeadlines";

export const AdminCollaborationHeadlines = ({
  selectedEducator,
  sharedClassId,
  onClassChange,
  onGoToCollaboration,
  adminUserData,
}) => {
  if (!selectedEducator) return null;
  return (
    <CollaborationHeadlines
      key={selectedEducator.id}
      educatorId={selectedEducator.id}
      teacherEmail={selectedEducator.email}
      sharedClassId={sharedClassId}
      onClassChange={onClassChange}
      onGoToCollaboration={onGoToCollaboration}
      adminUserData={adminUserData}
    />
  );
};
